import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.jpg'


const _withScopeId = n => (_pushScopeId("data-v-081bb905"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-header" }
const _hoisted_2 = { class: "header-container container" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo box-border" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Hope for Children NFT", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "logo-container",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.routerHome && _ctx.routerHome(...args)))
        }, _hoisted_6),
        _renderSlot(_ctx.$slots, "left", {}, undefined, true)
      ]),
      _renderSlot(_ctx.$slots, "right", {}, undefined, true)
    ])
  ]))
}